import { createFileRoute, redirect } from '@tanstack/react-router'
import { decodeId } from '@/lib/short-uuid'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/models/$modelId'
)({
  params: {
    parse: (rawParams: { modelId: string }) => {
      try {
        return { modelId: decodeId(rawParams.modelId) }
      } catch {
        return { modelId: rawParams.modelId }
      }
    },
  },
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/org/$orgId/workspace/$workspaceId/roster/$talentId',
      params: {
        orgId: params.orgId,
        workspaceId: params.workspaceId,
        talentId: params.modelId,
      },
      replace: true,
    })
  },
})
